import { defineComponent as _defineComponent } from 'vue'
import type { CreditFragment } from '@/pages/graphql/fragments/TitleDetails.fragment';

import { SnowplowPersonContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { CollectionType } from '@/enums/collection-type';

import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCreditName',
  props: {
    credit: null
  },
  setup(__props: any) {

const props = __props as {
	credit: CreditFragment;
};



const router = useRouter();

const userStore = useUserStore();
const filterStore = useFilterStore();

function clicked({ searchString, personId }: { searchString?: string; personId?: number }) {
	TrackingHelper.trackEvent(
		'persons_credit_name',
		{
			action: 'clicked',
			label: props.credit?.role,
			property: `${personId}`,
		},
		// credit prop sets a non-null default value but TS isn't catching it (Vue 2)
		[new SnowplowPersonContext(personId!, searchString!)]
	);

	if (!props.credit?.profilePath) {
		userStore.saveSearchTerm(searchString);
		const newRoute = filterStore.updateRouterState({
			collectionType: CollectionType.SEARCH,
			routeQuery: { q: searchString, person_id: personId },
		});

		if (newRoute) router.push(newRoute);
	}
}

return { __sfc: true,props, router, userStore, filterStore, clicked }
}

})